import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, ref, markRaw } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { Close } from "@element-plus/icons";
export default defineComponent({
  components: {
    Close: Close
  },
  props: {
    accept: {
      type: String,
      default: ".png,.jpg,.jpeg,.gif"
    },
    limit: {
      type: Number,
      default: 9,
      require: true
    }
  },
  emits: ["update:file", "file"],
  setup: function setup(props, context) {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //上传图片


    var baseUrl = process.env.VUE_APP_BASE_URL;
    var fileList = ref([]);
    var srcList = ref([]);

    function request(_x) {
      return _request.apply(this, arguments);
    } //图片超出时提醒
    // function onExceed() {
    //   ElMessage.error(`最多只能上传${props.limit}个文件`);
    // }
    // //上传之前的文件判断


    function _request() {
      _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var formData, _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();
                formData.append("file", val.file);
                _context.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["upload"](formData);

              case 4:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                fileList.value.push(data.fileName);
                upfileList();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _request.apply(this, arguments);
    }

    var arr = [];

    function beforeAvatarUpload(val) {
      //限制图片重复
      var index = arr.findIndex(function (v) {
        return v == val.name;
      });

      if (index > -1) {
        ElMessage.error("该照片已存在于上传列表");
        return false;
      } else {
        //图片超出时提醒
        if (fileList.value.length + 1 == props.limit) {
          ElMessage.error('已到达图片上限');
        }
      }

      arr.push(val.name);
      var isJPG = val.type.search("image") !== -1;
      var isLt10M = val.size / 1024 / 1024 < 10;

      if (!isJPG) {
        ElMessage.error("文件格式错误");
      }

      if (!isLt10M) {
        ElMessage.error("上传图片大小不能超过 10MB!");
      }

      return isJPG && isLt10M;
    } //删除图片


    function handleRemove(index) {
      fileList.value.splice(index, 1);
      arr.splice(index, 1);
      upfileList();
    } //上传图片


    function upfileList() {
      fileList.value.forEach(function (item) {
        srcList.value.push(baseUrl + item);
      });
      context.emit("file", markRaw(fileList.value));
    } //编辑回显，重新赋值


    function editFile(val) {
      fileList.value = val;
    }

    return {
      request: request,
      handleRemove: handleRemove,
      fileList: fileList,
      //onExceed,
      upfileList: upfileList,
      beforeAvatarUpload: beforeAvatarUpload,
      editFile: editFile,
      baseUrl: baseUrl,
      srcList: srcList
    };
  }
});